export default __webpack_public_path__ + "static/media/primaryButton.6614a3ec.png";